import { createStore } from 'redux';
import reducer from './reducers';

const Store = process.env.NODE_ENV === 'test' ? (
  null
) : createStore(
  reducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
);

export const getDispatch = () => {
  const { dispatch } = process.env.NODE_ENV === 'test' ? window.store : Store;

  return dispatch;
};

export default Store;
